module.exports = __webpack_public_path__ + "img/5-3.2c33ce60.png";